



































































































































































































































































import { Vue, Component, Ref } from "vue-property-decorator";
import store from "@/store";
//  utilities
import dateHelper from "@/Scripts/utilities/date-helper";
import moment from "moment";
//  types
import { DataQualityHeader, IndicatorData } from "@/types/dataQuality/dataQualityTable";
import { headers } from "./VDataTableHeaders/DataOutliers";
import { DataOutlier, FeatureConfig } from "@/types/dataQuality/dataOutliers";
//  components
import ManageModal from "@/components/dataQuality/OutliersModals/ManageModal.vue";
import HistoricalModal from "@/components/dataQuality/OutliersModals/HistoricalModal.vue";
import ThresholdsModal from "@/components/dataQuality/OutliersModals/ThresholdsModal.vue";
import OutlierFeaturesModal from "@/components/dataQuality/OutliersModals/OutlierFeaturesModal.vue";
import DataOutliersTable from "@/components/dataQuality/DataOutliersTable/index.vue";
import OutlierTimelineModal from "@/components/dataQuality/OutlierTimelineModal.vue";
import AllTimelinesModal from "@/components/dataQuality/AllTimelinesModal.vue";
import dataQualityClient from "@/Scripts/clients/data-quality-client.js";
//  modules
import { getModule } from "vuex-module-decorators";
import DataQualityModule from "@/store/clients/DataQuality.module";
import VesselsModule from "@/store/clients/Vessels.module";
import UserModule from "@/store/clients/User.module";
import SnackbarModule from "@/store/clients/Snackbar.module";
import { data } from "jquery";
import outageHubConnection from "@/utilities/signalr/signalr-outagehub-service";
import { HubConnectionState } from "@microsoft/signalr";

const Vessels = getModule(VesselsModule, store);
const DataQuality = getModule(DataQualityModule, store);
const User = getModule(UserModule, store);
const Snackbar = getModule(SnackbarModule, store);

@Component({
  components: {
    DataOutliersTable,
    ManageModal,
    HistoricalModal,
    ThresholdsModal,
    OutlierFeaturesModal,
    OutlierTimelineModal,
    AllTimelinesModal,
  },
})
export default class DataOutliers extends Vue {
  @Ref("RefManageModal") RefManageModal!: any;

  searchQuery = "";
  ManageModal = false;
  HistoricalModal = false;
  ThresholdsModal = false;
  OutlierFeaturesModal = false;
  timelineModal = false;
  allTimelinesModal = false;
  isThresholdsModalDataLoading = false;
  isTableReady = false;
  timelineData = {
    vesselId: 0,
    vesselName: "",
    featureName: "",
    featureNames: [] as string[],
  };
  autoRemoveDialog = false;
  autoRemoveDialogData = { vesselId: 0, enabled: false };
  // TODO current dayte and year back
  dates: string[] = [moment().subtract(1, "years").format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")];
  date = moment().format("YYYY-MM-DD");
  maxDate = moment().format("YYYY-MM-DD");
  menu = false;
  headers: DataQualityHeader[] = headers;
  featureConfigs: FeatureConfig[] = [];
  updateDebounceTimer: number | null = null;
  currentVesselName = "";

  // @GETTERS
  get isEnvDevelopment(): boolean {
    return process.env.NODE_ENV !== "production";
  }

  vesselName(vesselId: number): string | undefined {
    const vesselName = Vessels.extendedVessels.find(vessel => vessel.id === vesselId)?.name;
    if (!vesselName) return;
    return vesselName;
  }

  get loadingState() {
    return DataQuality.loadingState;
  }

  get dateRangeText() {
    return `${moment(this.dates[0]).format("ll")} - ${moment(this.dates[1]).format("ll")}`;
  }

  get dateRange() {
    return `${moment(this.dates[0]).format("DD MMM")} - ${moment(this.dates[1]).format("DD MMM")}`;
  }

  get queryRequest(): { companyId: number | null; fromDate?: string; toDate?: string } {
    return { companyId: User.userCompanyId, fromDate: this.dates[0], toDate: this.dates[1] };
  }

  get userCompanyId(): number | null {
    return User.userCompanyId;
  }

  get outlierList(): { featureName: string; vesselId: number; vesselName: string; outliers: DataOutlier[] }[] {
    return DataQuality.companyOutliers
      .map(item => {
        const vessel = Vessels.extendedVessels.find(v => v.id === item.vesselId);
        return item.data.map(indicator => {
          return {
            vesselId: item.vesselId,
            vesselName: vessel ? vessel.name : "Unknown Vessel",
            featureName: indicator.featureName,
            outliers: indicator.outliers || [],
          };
        });
      })
      .flat();
  }

  get uniqueFeatureNames(): string[] {
    const featureNames = this.outlierList.map(item => item.featureName);
    return Array.from(new Set(featureNames));
  }

  get rows(): any {
    var rows = DataQuality.companyOutliers.map((item, index) => {
      const vesselName = this.vesselName(item.vesselId);
      const indicators = item.data.reduce((acc: any, indicator) => {
        acc[indicator.featureName.replace(/\s/g, "")] = {
          value: indicator.value,
          unmanagedCount: indicator.unmanagedCount,
          autoRemovedCount: indicator.autoRemovedCount,
          physicalBoundsCount: indicator.physicalBoundsCount,
          smartOutliersCount: indicator.smartOutliersCount,
          detectionTime: indicator.detectionTime,
          link: null,
        };
        return acc;
      }, {});
      return {
        key: index,
        vesselId: item.vesselId,
        vesselName: {
          value: vesselName ?? "Uknown Vessel",
          link: vesselName ? `/Vessel/${item.vesselId}/${encodeURIComponent(vesselName)}` : null,
        },
        overallStatus: {
          value: item.overallStatus,
          link: null,
        },
        ...indicators,
        autoRemove: {
          value: item.autoRemoveEnabled ?? false,
          link: null,
        },
        settings: {
          value: null,
          link: null,
        },
      };
    });
    if (this.searchQuery && this.searchQuery.trim()) {
      const query = this.searchQuery.toLowerCase();
      return rows.filter(item => item.vesselName.value.toLowerCase().includes(query));
    }

    return rows;
  }
  // @METHODS
  async setDateRange(date: string): Promise<void> {
    (this.$refs.datepickerMenu as any).save(date);
    await DataQuality.fetchCompanyOutliers(this.queryRequest);
  }

  async openThresholdsModal(vesselId: string): Promise<void> {
    this.isThresholdsModalDataLoading = true;
    this.ThresholdsModal = true;
    this.currentVesselName = this.vesselName(Number(vesselId)) || "";
    this.featureConfigs = await DataQuality.fetchFeatureConfigs(vesselId);
    if (this.featureConfigs.length === 0) {
      this.featureConfigs = this.uniqueFeatureNames.map(name => {
        return {
          featureName: name,
          vesselId: Number(vesselId),
          lowerBound: 0,
          upperBound: 0,
        };
      });
    }
    this.isThresholdsModalDataLoading = false;
  }

  onAutoRemoveToggle(payload: { vesselId: number; enabled: boolean }): void {
    this.autoRemoveDialogData = { vesselId: payload.vesselId, enabled: payload.enabled };
    this.autoRemoveDialog = true;
  }

  async confirmAutoRemoveToggle(applyToExisting: boolean): Promise<void> {
    this.autoRemoveDialog = false;
    const { vesselId, enabled } = this.autoRemoveDialogData;
    try {
      await dataQualityClient.updateAutoRemoveConfig({ vesselId, enabled, applyToExisting });
      if (applyToExisting) {
        // Refresh the table data to reflect the changes
        await DataQuality.fetchCompanyOutliers(this.queryRequest);
      }
    } catch (error) {
      console.error("Failed to update auto-remove config:", error);
    }
  }

  showOutliersInManageModal(indicatorData: IndicatorData): void {
    this.RefManageModal.setSelectedOutliers({ feature: indicatorData.column, vesselId: indicatorData.vesselId });
  }

  async updateFeatureConfigs(featureConfigs: FeatureConfig[]) {
    try {
      await DataQuality.updateFeatureConfigs(featureConfigs);

      Snackbar.showSnackbar({ text: "Outliers will update within a few minutes.", color: "info", timeout: 15000 });
    } catch (error) {
      console.error(error);
    }
  }

  async recalculateOutliers(vesselId: string): Promise<void> {
    try {
      await DataQuality.recalculateOutliers(vesselId);
      await Promise.all([DataQuality.fetchCompanyOutliers(this.queryRequest), DataQuality.fetchFeatures()]);

      Snackbar.showSnackbar({ text: "Smart Outlier recalculation triggered successfully", color: "success", timeout: 3000 });
      setTimeout(() => {
        Snackbar.showSnackbar({ text: "Smart Outliers will update within a few minutes.", color: "info", timeout: 15000 });
      }, 3000);
    } catch (error) {
      console.error(error);
    }
  }

  async onOutlierStateChanged(): Promise<void> {
    await DataQuality.fetchCompanyOutliers(this.queryRequest);
  }

  showTimeline(indicatorData: IndicatorData): void {
    const vesselId = typeof indicatorData.vesselId === "string" ? parseInt(indicatorData.vesselId) : indicatorData.vesselId;
    if (!vesselId || !indicatorData.featureName) return;

    const vesselName = this.vesselName(vesselId);
    if (!vesselName) return;

    this.timelineData = {
      vesselId: vesselId,
      vesselName: vesselName,
      featureName: indicatorData.featureName,
      featureNames: [], // OutlierTimelineModal doesn't use this, but AllTimelinesModal needs it
    };
    this.timelineModal = true;
  }

  showVesselTimelines(vesselData: { vesselId: number; vesselName: string }): void {
    const vesselName = this.vesselName(vesselData.vesselId);
    if (!vesselName) return;

    // Precompute feature names to avoid expensive computation during modal render
    const featureNames = this.getFeatureNamesForVessel(vesselData.vesselId);

    this.timelineData = {
      vesselId: vesselData.vesselId,
      vesselName: vesselName,
      featureName: "",
      featureNames: featureNames, // Store precomputed feature names
    };
    this.allTimelinesModal = true;
  }

  getFeatureNamesForVessel(vesselId: number): string[] {
    // Direct access to raw data to avoid computed property overhead
    const vesselData = DataQuality.companyOutliers.find(item => item.vesselId === vesselId);
    if (!vesselData) return [];
    return vesselData.data.map(indicator => indicator.featureName);
  }
  // SignalR methods
  private async waitUntilConnected() {
    if (outageHubConnection.state === HubConnectionState.Connected) return;
    if (outageHubConnection.state === HubConnectionState.Disconnected) {
      await outageHubConnection.start();
      return;
    }
    await new Promise<void>(resolve => {
      const t = setInterval(() => {
        if (outageHubConnection.state === HubConnectionState.Connected) {
          clearInterval(t);
          resolve();
        }
      }, 50);
    });
  }

  private onOutlierUpdated = (outlier: any, vesselInfo: any) => {
    this.updateVesselOutliers(outlier);
  };

  buildHeaders(): void {
    const uniqueIndicatorsMap = new Map<string, any>();
    DataQuality.companyOutliers.forEach(item => {
      item.data.forEach(indicator => {
        const key = indicator.featureName;
        if (!uniqueIndicatorsMap.has(key)) {
          uniqueIndicatorsMap.set(key, indicator);
        }
      });
    });

    const dataIndicatorHeaders = Array.from(uniqueIndicatorsMap.values()).map(indicator => ({
      text: indicator.featureName,
      type: "percentIndicator",
      value: indicator.featureName.replace(/\s/g, ""),
      width: "110px",
      align: "center",
      class: "text-center",
      sortable: false,
    }));
    //  add auto-remove column
    dataIndicatorHeaders.push({
      text: "Automatic removal",
      type: "autoRemove",
      align: "center",
      value: "autoRemove",
      class: "text-center",
      sortable: false,
      width: "100px",
    });
    //  add settings column
    dataIndicatorHeaders.push({
      text: "",
      type: "settings",
      align: "center",
      value: "settings",
      class: "text-center",
      sortable: false,
      width: "70px",
    });
    this.headers = [...headers, ...dataIndicatorHeaders];
  }

  async onFeaturesSaved(): Promise<void> {
    this.isTableReady = false;
    await DataQuality.fetchCompanyOutliers(this.queryRequest);
    this.buildHeaders();
    this.isTableReady = true;
  }

  // @HOOKS
  async created(): Promise<void> {
    await Promise.all([Vessels.refreshExtendedVessels(), DataQuality.fetchCompanyOutliers(this.queryRequest), DataQuality.fetchFeatures()]);

    // Setup SignalR connection
    outageHubConnection.off("OutlierUpdated", this.onOutlierUpdated);
    outageHubConnection.on("OutlierUpdated", this.onOutlierUpdated);

    if (this.userCompanyId !== null && this.userCompanyId !== undefined) {
      try {
        await this.waitUntilConnected();
        await outageHubConnection.invoke("JoinGroup", `company-${this.userCompanyId}`);
      } catch (e) {
        console.error("Failed to join SignalR group:", e);
      }
    }

    this.buildHeaders();
    this.isTableReady = true;
  }

  beforeDestroy() {
    outageHubConnection.off("OutlierUpdated", this.onOutlierUpdated);
    if (this.userCompanyId !== null && this.userCompanyId !== undefined) {
      outageHubConnection.invoke("LeaveGroup", `company-${this.userCompanyId}`).catch(() => {});
    }
    if (this.updateDebounceTimer) {
      clearTimeout(this.updateDebounceTimer);
    }
  }

  updateVesselOutliers(updatedRow: {
    vesselId: number;
    overallStatus?: number;
    data: Array<{ featureName: string; value: number; unmanagedCount?: number; autoRemovedCount?: number; physicalBoundsCount?: number; smartOutliersCount?: number; detectionTime?: string; outliers: DataOutlier[] | null }>;
  }): void {
    // Debounce updates to prevent multiple rapid refreshes
    if (this.updateDebounceTimer) {
      clearTimeout(this.updateDebounceTimer);
    }

    this.updateDebounceTimer = setTimeout(() => {
      DataQuality.companyOutliers.forEach(item => {
        if (item.vesselId === updatedRow.vesselId) {
          updatedRow.data.forEach(newInd => {
            item.data.forEach(indicator => {
              if (indicator.featureName === newInd.featureName) {
                indicator.value = newInd.value;
                indicator.unmanagedCount = newInd.unmanagedCount;
                indicator.autoRemovedCount = newInd.autoRemovedCount;
                indicator.physicalBoundsCount = newInd.physicalBoundsCount;
                indicator.smartOutliersCount = newInd.smartOutliersCount;
                indicator.detectionTime = newInd.detectionTime ?? indicator.detectionTime;
                indicator.outliers = newInd.outliers ?? indicator.outliers;
              }
            });
          });

          if (typeof updatedRow.overallStatus === "number") {
            item.overallStatus = updatedRow.overallStatus;
          } else {
            item.overallStatus = item.data.reduce((acc: number, indicator: any) => {
              return indicator.value > acc ? indicator.value : acc;
            }, 0);
          }
        }
      });
    }, 300);
  }
}
